import {
  GET_DOMAINS_BY_NAME,
  GET_FLOWS,
  GET_FLOWS_WITH_DOMAINS
} from "@core/store/action-constants";
import {
  SET_FLOWS,
  UPDATE_PAGINATION,
  UPDATE_FLOWS_FILTERS,
  SET_DOMAINS_BY_NAME,
  UPDATE_FLOWS_DOMAINS, SET_EMPTY
} from "@core/store/mutation-constants";
import { RootState } from "@core/store/root-state";
import { Flow, FlowsFilters, FlowsState } from "@core/store/types/webmaster/flows";
import { ActionTree, Module, MutationTree } from "vuex";
import { OfferService } from "@core/services/common/offer/OfferService";
import Vue from "vue";
import { DomainsService } from "@core/store/logic/webmaster/domains/domainsService";
import { Pagination } from "@core/store/types/common";
import { stateUpdater } from "@core/store/modules/common/stateUpdater";

const initialState = (): FlowsState => {
  return {
    flows: null,
    pagination: {
      perPage: 10,
      page: 1
    },
    filters: {
      offerId: null
    }
  };
};

const state: () => FlowsState = initialState;

const mutations: MutationTree<FlowsState> = {
  [SET_EMPTY] (state): void {
    Object.assign(state, initialState());
  },
  
  [SET_FLOWS] (state: FlowsState, flows: FlowsState["flows"]): void {
    state.flows = flows;
  },

  [UPDATE_PAGINATION] (state: FlowsState, pagination: Pagination): void {
    state.pagination = { ...state.pagination, ...pagination };
  },

  [UPDATE_FLOWS_FILTERS] (state: FlowsState, filters: FlowsFilters): void {
    state.filters = { ...state.filters, ...filters };
  },
  
  [SET_DOMAINS_BY_NAME] (state: FlowsState, { isHttps, id }): void {
    if (state.flows && state.flows.items) {
      const flowsIndex = state.flows.items.findIndex((flows: Flow) => flows.id === id);
      Vue.set(state.flows.items, flowsIndex, { ...state.flows.items[flowsIndex], isHttps });
    }
  },
  
  ...stateUpdater.mutations
};

const actions: ActionTree<FlowsState, RootState> = {
  async [GET_FLOWS] ({ commit, state }): Promise<void> {
    const { pagination: { perPage: limit, page } } = state;
    const offset = (page - 1) * limit;

    const { data: { landingFlows } } = await OfferService.getFlows(limit, offset, state.filters);

    commit(SET_FLOWS, landingFlows);
  },
  
  async [GET_FLOWS_WITH_DOMAINS] ({ dispatch }): Promise<void> {
    await dispatch(GET_FLOWS);
    dispatch(UPDATE_FLOWS_DOMAINS);
  },
  
  [UPDATE_FLOWS_DOMAINS] ({ state, dispatch }): void {
    state.flows?.items?.forEach((item: Flow) => {
      const webmasterDomain = item.options?.webmasterDomain;
      if (webmasterDomain) {
        dispatch(GET_DOMAINS_BY_NAME, { strictName: webmasterDomain, id: item.id });
      }
    });
  },
  
  async [GET_DOMAINS_BY_NAME] ({ commit }, { strictName, id }): Promise<void> {
    const filters = { strictName, includeSystemDomains: true };
    const { data: { landingDomains } } = await DomainsService.getDomains(filters, 25, 0);
    const isHttps = landingDomains.items?.[0]?.isHttps;
    
    commit(SET_DOMAINS_BY_NAME, { isHttps, id });
  },

  [UPDATE_PAGINATION] ({ commit }, pagination: Pagination): void {
    commit(UPDATE_PAGINATION, pagination);
  },

  [UPDATE_FLOWS_FILTERS] ({ commit }, filters: FlowsFilters): void {
    commit(UPDATE_FLOWS_FILTERS, filters);
  },
  
  [SET_EMPTY] ({ commit }): void {
    commit("SET_EMPTY");
  }
};
export const offerFlows: Module<FlowsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};
